import React, { useState, useMemo } from 'react'


import DEIPageClusterChart from '../DEIPageClusterChart/DEIPageClusterChart'
import DEIPageClusterChartLegend from '../DEIPageClusterChartLegend/DEIPageClusterChartLegend'

import { DEI_COLORS } from "../constants"

import {
  DEIPageFullTeamRaceContentDIV,
  DEIPageFullTeamRaceChartDIV,
  DEIPageFullTeamRaceLegendDIV,
  DEIPageFullTeamRaceGridDIV,
  DEIPageFullTeamRaceSECTION,
} from './DEIPageFullTeamRace.styles'

const DEIPageFullTeamRace = ({ race }) => {
  const [activeDate, setactiveDate] = useState(race.dates[0])
  const [activeType, setactiveType] = useState(null)
  const types = useMemo(() => activeDate.percentages.map(type => type), [activeDate])
  const colors = [
    DEI_COLORS.PINK,
    DEI_COLORS.YELLOW,
    DEI_COLORS.LIGHT_BLUE,
    DEI_COLORS.BLUE,
    DEI_COLORS.PURPLE,
    DEI_COLORS.WHALE_TAIL,
    DEI_COLORS.NEUTRAL,
  ]

  return (
    <DEIPageFullTeamRaceSECTION>
      <div className="container">
        <DEIPageFullTeamRaceGridDIV>
          <div className="column column--2-12-M column--3-11-L">
            <DEIPageFullTeamRaceContentDIV>
              <h2>Help&nbsp;Scout by the numbers</h2>
              <p className="type--text-L">We acknowledge that all axes of diversity are important — not just the ones reported on here. Our goal is to implement equitable policies and practices that foster an inclusive environment for all.</p>
            </DEIPageFullTeamRaceContentDIV>
          </div>
          <div className="column column--2-6-M column--2-7-L">
            <DEIPageFullTeamRaceLegendDIV>
              <DEIPageClusterChartLegend
                activeDateTitle={activeDate.title}
                colors={colors}
                footnote={activeDate.footnote}
                dates={race.dates}
                onHoverType={type => setactiveType(type)}
                onSelectDate={date => setactiveDate(date)}
                title="Full team by race"
                types={types}
              />
            </DEIPageFullTeamRaceLegendDIV>
          </div>
          <div className="column column--7-13-M">
            <DEIPageFullTeamRaceChartDIV>
              <DEIPageClusterChart
                activeType={activeType}
                colors={colors}
                percentages={activeDate.percentages}
              />
            </DEIPageFullTeamRaceChartDIV>
          </div>
        </DEIPageFullTeamRaceGridDIV>
      </div>
    </DEIPageFullTeamRaceSECTION>
  )
}

export default DEIPageFullTeamRace
